import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill, secondaryOutline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M78.7606 43.88C78.7606 43.88 60.0805 33.63 56.0305 28.9C51.5305 23.64 51.7305 1 51.7305 1H39.3105C39.3105 1 39.6206 23.75 35.0106 28.9C30.1206 34.36 12.0605 43.22 12.0605 43.22C18.2505 57.8 35.9905 67.5 45.5305 67.5C55.0406 67.5 72.5606 58.46 78.7606 43.88Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.0503 58.1199C85.2503 47.1199 82.7203 44.8299 77.6003 41.6199C77.4603 41.5399 63.5003 33.6499 63.5003 33.6499C63.5003 33.6499 58.8603 42.0699 45.6503 42.0699C32.4403 42.0699 27.1203 33.6499 27.1203 33.6499C27.1203 33.6499 13.2603 41.5599 13.1003 41.6599C7.75031 45.0399 5.2703 47.4899 3.7403 58.1199C2.1103 69.4799 1.82031 71.1899 1.82031 71.1899H88.9703C88.9703 71.1899 88.7303 68.3199 87.0503 58.1199Z"
        fill={secondaryFill}
        stroke={secondaryOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M70.1708 37.53C70.1708 37.53 64.9608 47.35 45.4008 47.35C25.8408 47.35 20.6309 37.53 20.6309 37.53"
        stroke={secondaryOutline}
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M31.8008 28.8501L37.4108 52.1901L38.4008 71.3501H1.30078C1.30078 71.3501 1.96078 65.7401 2.95078 58.5801C3.81078 52.3901 4.12078 47.3201 8.45078 44.1601C12.5208 41.1901 25.2908 34.1401 25.2908 34.1401L31.8008 28.8501Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M25.3108 34.1301C25.3108 34.1301 21.2408 52.4101 21.3508 54.8301C21.4108 56.1701 22.0108 57.9101 26.3008 56.3701C30.5908 54.8301 37.2008 52.7401 37.2008 52.7401"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path d="M6.48047 47.01L13.4205 71.34" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M7.36035 45.03L14.9604 71.67" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M58.9906 28.8501L53.3806 52.1901L52.3906 71.3501H89.4906C89.4906 71.3501 88.8306 65.7401 87.8406 58.5801C86.9806 52.3901 86.6706 47.3201 82.3406 44.1601C78.2706 41.1901 65.5006 34.1401 65.5006 34.1401L58.9906 28.8501Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M65.4906 34.1301C65.4906 34.1301 69.5606 52.4101 69.4506 54.8301C69.3906 56.1701 68.7906 57.9101 64.5006 56.3701C60.2106 54.8301 53.6006 52.7401 53.6006 52.7401"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path d="M84.3209 47.01L77.3809 71.34" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M83.4308 45.03L75.8408 71.67" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M56.8707 59.23C57.7599 59.23 58.4807 58.5092 58.4807 57.62C58.4807 56.7308 57.7599 56.01 56.8707 56.01C55.9815 56.01 55.2607 56.7308 55.2607 57.62C55.2607 58.5092 55.9815 59.23 56.8707 59.23Z"
        fill={fill}
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.3983"
          y1="40.1926"
          x2="45.3983"
          y2="14.1961"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
